window.addEventListener('load', function () {
	var authorPostSwiper = new Swiper('.wrap-author .swiper-container', {
		loop: true,

		// If we need pagination
		pagination: '.wrap-author .swiper-pagination',

		// Navigation arrows
		nextButton: '.wrap-author .button-next',
		prevButton: '.wrap-author .button-prev',

		paginationClickable: true,
	});
}, true);
